import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { Nav, Navbar, Button, Container } from "react-bootstrap";
import React, { useState } from "react";
import { loginRequest } from "../authConfig";
import logo from "../public/images/AlertOps_Logo.png";
import "../styles/App.css";
import { Link } from "react-router-dom";

export const NavigationBar = (props) => {
    const { instance } = useMsal();
    const [menuOpen, setMenuOpen] = useState(false);

    const handleLogin = () => {
        instance.loginPopup(loginRequest)
            .catch((error) => console.log(error))
    };

    return (
        <nav className="modern-navbar">
            <div className="navbar-content">
                <div className="navbar-logo-section">
                    <a href="/signuplist" className="navbar-logo-link">
                        <img src={logo} className="navbar-logo-img" alt="AlertOps" />
                    </a>
                </div>
                <button className="navbar-hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
                    <span className="hamburger-bar"></span>
                    <span className="hamburger-bar"></span>
                    <span className="hamburger-bar"></span>
                </button>
                <div className={`navbar-links-section ${menuOpen ? "open" : ""}`}>
                    <Nav className="navbar-links">
                        <AuthenticatedTemplate>
                            <Nav.Link as={Link} to="/signuplist" className="navbar-link">Signups</Nav.Link>
                            <Nav.Link as={Link} to="/cspage" className="navbar-link">Customer</Nav.Link>
                            <Nav.Link as={Link} to="/customerinfo" className="navbar-link">Customer Info</Nav.Link>
                        </AuthenticatedTemplate>
                    </Nav>
                </div>
                <div className="navbar-auth-section">
                    <AuthenticatedTemplate>
                        <Button 
                            className="navbar-signout-btn navbar-signout-btn-red" 
                            onClick={() => instance.logoutRedirect({ postLogoutRedirectUri: "/" })}
                        >
                            <span role="img" aria-label="Sign Out" style={{marginRight: '7px', fontSize: '1.1em'}}>🚪</span>Sign Out
                        </Button>
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                        <Button onClick={handleLogin} className="navbar-login-btn">Login</Button>
                    </UnauthenticatedTemplate>
                </div>
            </div>
        </nav>
    );
};
